module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213102_edited.fd728acb.jpg";